import gql from 'graphql-tag';

import { AvatarPhoto } from '../../../../graphql/fragments/account';
import { AlbumLocationFields } from '../../../../graphql/fragments/album';
import { PhotoUrlTypeFields } from '../../../../graphql/fragments/custom-prints';

export const HierarchySearchItemFields = gql`
  fragment HierarchySearchItemFields on IHierarchySearchItem {
    ... on IHierarchySearchItem {
      id
      item_type
    }
    ... on HierarchySearchAlbumFolderItem {
      album_folder {
        id
        name
        description
        album_type
        album_subtype
        created_at
        start_date
        end_date
        event_venue
        join_code
        is_web_gallery
        joins_enabled
        cover_photos(slice: { limit: 1 }) {
          count
          total
          records {
            id
            faces_box
            thumbnail_urls(ignore_watermark: true) {
              ...PhotoUrlTypeFields
            }
          }
        }
        children {
          albums {
            total
            records {
              name
              cover_photo {
                id
                faces_box
                thumbnail_urls {
                  ...PhotoUrlTypeFields
                }
              }
            }
          }
        }
        start_date
        end_date
        account {
          id
          username
          name
          organization_name
          ...AvatarPhoto
        }
        has_password
        public_join_code_verification_enabled
        auto_contributor_settings {
          upload_access
        }
        location {
          ...AlbumLocationFields
        }
        tags(slice: { limit: 100 }) {
          records {
            id
            ... on IAlbumFolderTag {
              name
              type
            }
          }
        }
        all_photos_mode
      }
    }
    ... on HierarchySearchAlbumItem {
      album {
        id
        name
        start_date
        end_date
        album_type
        album_subtype
        join_code
        is_web_gallery
        joins_enabled
        cover_photo {
          id
          faces_box
          thumbnail_urls {
            ...PhotoUrlTypeFields
          }
        }
        creator {
          id
          username
          name
          organization_name
          ...AvatarPhoto
        }
        auto_contributor_settings {
          upload_access
        }
        has_password
        public_join_code_verification_enabled
        album_location {
          ...AlbumLocationFields
        }
        all_photos_mode
        root_album_folder {
          id
          individual_albums
          join_code
        }
      }
    }
  }
  ${AvatarPhoto}
  ${PhotoUrlTypeFields}
  ${AlbumLocationFields}
`;
